import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Chip from "@material-ui/core/Chip";
import clsx from "clsx";

export const useStyles = makeStyles(
  (theme) => (
    {
      chipRed: {
        backgroundColor: '#b70000',
        fontWeight: '600',
        color: '#FFFFFF'
      },
      marginChip: {
        marginRight: '3px',
        marginLeft: '3px',
      },
    }
  )
)
export const LabelIntruso = props  => {
  const classes = useStyles();
  return (
    <Chip size="small" label={props.label ? props.label : "Intruso"} className={clsx(classes.chipRed, classes.marginChip)}/>
  )
}

export default LabelIntruso;
